import proj_1 from "../assets/proj_1.png";
import proj_2 from "../assets/proj_2.png";
import proj_3 from "../assets/proj_3.png";
import proj_4 from "../assets/proj_4.png";
import proj_5 from "../assets/proj_5.png";
import proj_6 from "../assets/proj_6.png";

export const ProjectList = [
  {
    name: "Digital CV",
    image: proj_1,
    skills: "Python, Streamlit, CSS",
    url: "https://github.com/aazim-github/aazim-digital-resume",
  },
  {
    name: "go-serverless-aws",
    image: proj_2,
    skills: "Go, API Gateway, Lambda, DynamoDB",
    url: "https://github.com/aazim-github/go-serverless-aws",
  },
  {
    name: "go-email-checker-tool",
    image: proj_3,
    skills: "Go",
    url: "https://github.com/aazim-github/email-checker-tool",
  },
  {
    name: "go-movies-crud",
    image: proj_4,
    skills: "Go, github/mux",
    url: "https://github.com/aazim-github/go-movies-crud",
  },
  {
    name: "go-slack-age-bot",
    image: proj_5,
    skills: "Go, Slacker",
    url: "https://github.com/aazim-github/slack-age-bot",
  },
  {
    name: "go-slack-file-bot",
    image: proj_6,
    skills: "Go, Slack",
    url: "https://github.com/aazim-github/slack-file-bot",
  },
];